<template>
<div
    v-if="most_recent_message != null"
>
    <div
        class="alert_container"
    >
        <div
            class="alert"
        >
            {{most_recent_message}}
            <a v-on:click="onClickView">view</a>
        </div>
    </div>

    
    <m-other-conversations-more-dialog
        ref="more-dialog"
    />

</div>
</template>

<script>
const Time = require('@/js/time.js');
const E164 = require('@/js/E164.js');

export default {
    props: {
        conversation_id: {
            type: String,
            default: function() { return null; },
        },
    },

    data() {
        return {
            results: [],
            most_recent_message: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            if ( this.conversation_id == null )
            {
                this.results = [];
                return;
            }

            this.$rc.getOtherConversations(
                this.conversation_id,
            
                (data) => {
                    this.results = data.results;
                    this.most_recent_message = data.most_recent_message;
                },
            
                () => {
                    this.results = [];
                },
            );
        },

        age(time)
        {
            return Time.getHumanReadableAge(time);
        },

        onClickConversationChip(other)
        {
            this.$rc.toHomeForEndpoint(this.$router, other.org_endpoint, false, other.conversation_id);
        },

        onClickView()
        {   
            let title = 'Other Conversations';
            let other_conversations = this.results;
            this.$refs['more-dialog'].showDialog(title, other_conversations);
        }
    },

    watch: {
        conversation_id(newValue, oldValue) {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>

.author_label
{
    font-family: Roboto;
    font-size: 12px;
}

.alert_container
{
    text-align: center;

    margin-top: 15px;

}

/*.alert
{
    background-color: rgb(241,243,244);
    display: inline-block;
    padding: 15px;
    border-radius: 20px;
    font-family: Roboto;
    font-size: 16px;

    margin: 15px;
    margin-left: 65px;
    margin-right: 65px;
    text-align: left;
} */

.alert
{
    font-family: Roboto;
    font-size: 12px;

    margin: 15px;
}

.hint
{
    color: rgba(0,0,0,0.5);
    font-family: Roboto;
    font-size: 12px;
}
</style>